@if(isLoading()){
<div class="loader-overlay">
    <div class="loader-content">
        <img src="img/serveto2.png" alt="Serveto" class="pulsating-logo">
    </div>
</div>
}